import {
  ADD_PROJECT,
  ADD_PROJECT_FAILURE,
  ADD_PROJECT_SUCCESS,
  CLEAR_EDIT_PROJECT,
  DELETE_PROJECT,
  DELETE_PROJECT_FAILURE,
  DELETE_PROJECT_SUCCESS,
  EDIT_PROJECT,
  FETCH_PROJECTS,
  FETCH_PROJECTS_FAILURE,
  FETCH_PROJECTS_SUCCESS,
  PROJECTS_CLEAR_STATE,
  PROJECTS_STATUSES_UPDATED,
  RENAME_PROJECT,
  RENAME_PROJECT_FAILURE,
  RENAME_PROJECT_SUCCESS,
  CLEAR_CREATED_PROJECT,
  RETRY_PROJECT,
  RETRY_PROJECT_SUCCESS,
  RETRY_PROJECT_FAILURE,
  IMPORT_PROJECTS_SUCCESS,
  CLEAR_IMPORTED_PROJECTS,
  IMPORT_PROJECTS,
  SET_VIEW_PROJECTS_POSITION,
} from '@Pages/RetroSynthesis/RetroSynthesisProjects/constants';
import map from 'lodash/map';
import isNil from 'lodash/isNil';
import { ProjectStatus } from '@Pages/RetroSynthesis/constants';

export const initialState = {
  isLoading: false,
  response: undefined,
  error: undefined,
  projectToEdit: null,
  createdProject: null, // for AA page load { id, publishedParams, editorType, isEditProjectMode }
  importedProjects: null,
  lastViewedProjectId: null, // { scrollTop: last table scroll position, id: last project id }
};

// eslint-disable-next-line default-param-last
export default function reducer(state = initialState, action) {
  switch (action.type) {
    case FETCH_PROJECTS:
    case ADD_PROJECT:
    case IMPORT_PROJECTS:
    case RENAME_PROJECT:
    case DELETE_PROJECT:
    case RETRY_PROJECT:
      return { ...state, isLoading: true };
    case FETCH_PROJECTS_SUCCESS:
      return { ...state, isLoading: false, error: undefined, response: action.payload };
    case FETCH_PROJECTS_FAILURE:
      return { ...state, isLoading: false, error: action.payload, response: undefined };
    case ADD_PROJECT_SUCCESS:
      return {
        ...state,
        isLoading: false,
        // do not reset paging size after adding new project
        response: { size: state.response ? state.response.size : undefined },
        createdProject: action.payload,
      };
    case IMPORT_PROJECTS_SUCCESS:
      return { ...state, isLoading: false, importedProjects: action.payload };
    case RENAME_PROJECT_SUCCESS:
    case DELETE_PROJECT_SUCCESS:
    case RETRY_PROJECT_SUCCESS:
      return { ...state, isLoading: false };
    case SET_VIEW_PROJECTS_POSITION:
      return { ...state, lastViewedProjectPosition: action.payload };
    case ADD_PROJECT_FAILURE:
    case RENAME_PROJECT_FAILURE:
    case DELETE_PROJECT_FAILURE:
    case RETRY_PROJECT_FAILURE:
      return { ...state, isLoading: false, error: action.payload };
    case PROJECTS_STATUSES_UPDATED: {
      const { projectId, publishedStatus, publishedRouteCount, rtStatus, rtRouteCount, combinedRouteCount, position } = action.payload;

      if (!state.response || (publishedStatus === ProjectStatus.FINISHED && !publishedRouteCount)) {
        return state;
      }

      const newContent = map(state.response.content, (project) => {
        if (project.id === projectId) {
          return {
            ...project,
            ...(!isNil(publishedStatus) && { publishedStatus }),
            ...(!isNil(publishedRouteCount) && { publishedRouteCount }),
            ...(!isNil(rtStatus) && { rtStatus }),
            ...(!isNil(rtRouteCount) && { rtRouteCount }),
            ...(!isNil(combinedRouteCount) && { combinedRouteCount }),
            ...(!isNil(position) && { queuePosition: position.toString() }),
          };
        }
        if (project.childIds && project.childIds.includes(projectId) && project.childProjects) {
          return {
            ...project,
            childProjects: project.childProjects.map((childProject) => {
              if (childProject.id === projectId) {
                return {
                  ...childProject,
                  ...(!isNil(rtStatus) && { rtStatus }),
                  ...(!isNil(rtRouteCount) && { rtRouteCount }),
                  ...(!isNil(combinedRouteCount) && { combinedRouteCount }),
                  ...(!isNil(position) && { queuePosition: position.toString() }),
                };
              }
              return childProject;
            }),
          };
        }
        return project;
      });
      const response = { ...state.response, content: [...newContent] };
      return { ...state, response };
    }
    case PROJECTS_CLEAR_STATE:
      return { ...initialState };
    case EDIT_PROJECT:
      return { ...state, ...action.payload };
    case CLEAR_EDIT_PROJECT:
      return { ...state, projectToEdit: null };
    case CLEAR_CREATED_PROJECT:
      return { ...state, createdProject: null };
    case CLEAR_IMPORTED_PROJECTS:
      return { ...state, importedProjects: null };
    default:
      return state;
  }
}
